module.exports = __webpack_public_path__ + "static/media/office.c51d32bd.jpeg";